import { defineMessages } from 'react-intl';
import { flattenToAppURL, isInternalURL } from '@plone/volto/helpers';
import clearSVG from '@plone/volto/icons/clear.svg';
import navTreeSVG from '@plone/volto/icons/nav.svg';
import { getObjectBrowserOptions } from '@interaktivgmbh/volto-alttextgenerator/helpers';

const messages = defineMessages({
  title: {
    id: 'Title',
    defaultMessage: 'Title',
  },
  description: {
    id: 'Description',
    defaultMessage: 'Description',
  },
  width: {
    id: 'Width',
    defaultMessage: 'Width',
  },
  height: {
    id: 'Height',
    defaultMessage: 'Height',
  },
  image: {
    id: 'Image',
    defaultMessage: 'Image',
  },
  small: {
    id: 'Small',
    defaultMessage: 'Small',
  },
  medium: {
    id: 'Medium',
    defaultMessage: 'Medium',
  },
  large: {
    id: 'Large',
    defaultMessage: 'Large',
  },
  default: {
    id: 'Default',
    defaultMessage: 'Default',
  },
  narrow: {
    id: 'Narrow',
    defaultMessage: 'Narrow',
  },
  alt: {
    id: 'Alt text',
    defaultMessage: 'Alt text',
  },
  altAIGeneratedLabel: {
    id: 'Was this alt text generated by an AI?',
    defaultMessage: 'Was this alt text generated by an AI?',
  },
});

export function HighlightSchema(props) {
  const { intl } = props;
  const imageUrl = isInternalURL(props.data.url)
    ? flattenToAppURL(props.data.url)
    : props.data.url;

  return {
    block: 'highlightTeaserWithoutButton',
    fieldsets: [
      {
        id: 'default',
        title: 'Default',
        fields: [
          'imageUrl',
          'title',
          'description',
          'alt',
          'alt_ai_generated',
          'width',
          'height',
        ],
      },
    ],
    properties: {
      imageUrl: {
        title: intl.formatMessage(messages.image),
        value: imageUrl,
        icon: props.data.url ? clearSVG : navTreeSVG,
        iconAction: props.data.url
          ? () => {
              props.resetSubmitUrl();
              props.onChangeBlock(props.block, {
                ...props.data,
                url: '',
                alt: '',
                alt_ai_generated: false,
                model_used: '',
                generation_date: '',
              });
            }
          : () => props.openObjectBrowser(getObjectBrowserOptions(props)),
      },
      title: {
        title: intl.formatMessage(messages.title),
      },
      description: {
        title: intl.formatMessage(messages.description),
        widget: 'textarea',
      },
      alt: {
        title: intl.formatMessage(messages.alt),
        widget: 'textarea',
      },
      alt_ai_generated: {
        title: intl.formatMessage(messages.altAIGeneratedLabel),
        type: 'boolean',
      },
      width: {
        title: intl.formatMessage(messages.width),
        choices: [
          ['100%', '100%'],
          ['default', `${intl.formatMessage(messages.default)}`],
          ['narrow', `${intl.formatMessage(messages.narrow)}`],
        ],
        default: 'default',
      },
      height: {
        title: intl.formatMessage(messages.height),
        choices: [
          ['325px', `${intl.formatMessage(messages.small)}`],
          ['600px', `${intl.formatMessage(messages.medium)}`],
          ['800px', `${intl.formatMessage(messages.large)}`],
        ],
        default: '800px',
      },
    },
    required: [],
  };
}
